<template>
  <div id="card-add">
    <Spinner v-if="isLoading"/>
		<div class="sav-container sav-card sav-card-add">
			<div class="sav-card-header">
				<h2 class="sav-card-title">{{ cardHeader }}</h2>
			</div>
			<div class="sav-card-entries">
				<div class="sav-card-entry" v-for="(value, key, index) in cardHeaders" v-show="key != 'id' && key != 'informed'" :key="index">
					<h3>{{ cardHeaders[key] }}</h3>
					<input v-if="key == 'start_date' || key == 'end_date'" 
						:class="{ 'error': !inputData[index] && submitted }"
						:id="key" type="date" :name="key" v-model.trim="inputData[index]"
					>
					<input v-else-if="key == 'amount' || key == 'members'" 
						:class="{ 'error': !inputData[index] && submitted }"
						:id="key" type="number" :name="key" min="0" v-model.trim="inputData[index]"
					>
					<div v-else-if="key == 'plate'">
						<input 
							:class="{ 'error': !inputData[index] && submitted }"
							:id="key" type="text" :name="key" v-model.trim="inputData[index]" @blur="checkPlate(inputData[index])"
						>
						<label v-if="plateErrorMsg" class="error-msg-infield">{{ plateErrorMsg }}</label>
					</div>
					<textarea v-else-if="key == 'coverage' || key == 'region'" 
						:class="{ 'error': !inputData[index] && submitted }"
						:id="key" type="text" :name="key" v-model.trim="inputData[index]" rows="4"
					></textarea>
					<textarea v-else-if="key == 'notes' || key == 'address'" 
						:id="key" type="text" :name="key" v-model.trim="inputData[index]" rows="4"
					></textarea>
					<input v-else-if="key == 'docs_1' || key == 'docs_2' || key == 'docs_3' || key == 'docs_4'"
						:id="key" type="file" :name="key" accept="application/pdf, image/*" v-on:change="handleFileUpload(key)" multiple
					>
					<div v-else-if="key == 'dept'">
						<div class="flex">
							<label class="flex flex-align-items-center stavros-blue-mark" for="Stavros">ΣΤΑΥΡΟΣ</label>
							<input type="radio" id="Stavros" name="Stavros" value="Stavros" v-model="inputData[index]">
							<label class="flex flex-align-items-center asprovalta-blue-mark" for="expirAsprovaltaed">ΑΣΠΡΟΒΑΛΤΑ</label>
							<input type="radio" id="Asprovalta" name="Asprovalta" value="Asprovalta" v-model="inputData[index]">
						</div>
					</div>
					<div v-else-if="key == 'id'"></div>
					<input v-else 
						:class="{ 'error': !inputData[index] && submitted }"
						:id="key" type="text" :name="key" v-model.trim="inputData[index]" 
					>
				</div>
			</div>
			<div class="sav-card-footer">
				<span class="sav-card-log"></span>
				<div class="sav-card-buttons">
					<div v-if="errorMsg" id="error-msg" class="flex flex-align-items-center">
						<b>{{ errorMsg }}</b>
					</div>
					<button @click="validateForm" type="submit" class="sav-btn sav-btn-red">Καταχώρηση ασφάλειας</button>
				</div>
			</div>
		</div> 
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './Spinner.vue'

export default {
  props: ['category', 'cardHeaders'],
  components: {
		Spinner
  },
  data() {
		return {
			name: 'Add',
			apiUrl : this.$parent.$parent.apiUrl,
			editor: "Admin",
			isLoading: false,
			id: '',
			cardHeader: "Ασφάλεια",
			errorMsg: '',
			plateErrorMsg: '',
			emptyFieldErrorMsg: "Παρακαλώ συμπληρώστε όλα τα απαραίτητα πεδία.",
			inputData: [],
			submitted: false,
			file: {
				'docs_1': '',
				'docs_2' : '',
				'docs_3' : '',
				'docs_4' : ''
			},
			notRequiredFields: [ "notes", "address", "informed"],
			notRequiredFieldsIndices: []
		}
  },
  methods: {
    formatDate: function (date) {
        // format date dd/mm/yyyy
        let newDate = new Date(date);
        return this.sliceNumber(newDate.getDate(), 2) + "/" + this.sliceNumber(newDate.getMonth() + 1, 2) + "/" + this.sliceNumber(newDate.getFullYear(), 4)
    },
    sliceNumber: function(number, slice) {
        // return number with custom number of digits
        return ("0" + number).slice(-1 * slice);
    },
    initInputData: function () {
			let i = 0;
			// fill inputData with data
			let data = this.cardHeaders;
			for (let key in data) {
				if (i > 0 && key !== 'docs_1' && key !== 'docs_2' && key !== 'docs_3' && key !== 'docs_4' && key!== 'dept') { // do not include pdf (last header)
					
					this.inputData[i] = "";
					// add not required field indices to array
					if (this.notRequiredFields.includes(key)) {
						this.notRequiredFieldsIndices.push(i);
					}
				}
				if (key == 'dept') {
					this.inputData[i] = 'Stavros';
				}		
				i++;
			}
    },
    initCardHeader: function () {
        // create card header
        if (this.category == 'car') {
            this.cardHeader = "Ασφάλεια Αυτοκινήτου"
        } else if (this.category == 'moto') {
            this.cardHeader = "Ασφάλεια Μηχανής"
        } else if (this.category == 'house') {
            this.cardHeader = "Ασφάλεια Κατοικίας"
        } else {
            this.cardHeader = "Ασφάλεια Υγείας"
        }
		},
		checkPlate(plate) {
			const vm = this;
			let url = this.apiUrl + "/check-plate/" + this.category;
			let formData = {
				plate: plate,
				user: JSON.parse(localStorage.getItem('sav-erp-user')),
				token: this.$cookie.get('sav-erp-token'),
				refreshToken: this.$cookie.get('sav-erp-refresh-token')
			};

			let headers = { 
				headers: {
					'Content-type': 'application/json',
				}
			};
    
			axios.post(url, formData, headers)
				.then(response => {
					if (response.status == 200) {
						this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
						vm.plateErrorMsg = response.data.msg;
					}
				})
				.catch(error => {
					let response = error.response;
					
					if (response.status == 401) {
						localStorage.removeItem('user');    
						vm.$cookie.delete('sav-erp-token');
						vm.$cookie.delete('sav-erp-refresh-token');
						vm.$router.push("/login");
					}
				});
		},
		handleFileUpload(key){
			this.file[key] = document.getElementById(key).files;	
		},
		validateForm () {
			// flag for checking if user has submitted once
			this.submitted = true;

			let validated = true;

			// check if input elements are empty
			for (let index in this.inputData) {
				if (this.inputData[index] == "" && !this.notRequiredFieldsIndices.includes(parseInt(index))) { // avoid validating no required field indices
					validated = false;
				}
			}
			if (validated && !this.plateErrorMsg) {
				this.errorMsg = "";
				this.submit();
			} else {
				this.errorMsg = this.emptyFieldErrorMsg;
			}
		},
		submit () {
			// at first upload data to server and then upload the file if it exists
			this.isLoading = true;
			this.uploadData();
		},
		uploadData () {
			let vm = this;
			let formData = '';
			let url = this.apiUrl + '/post/' + this.category + '/add';
			let headers = { 
				headers: {
				'Content-type': 'application/json',
				}
			};

			// adjust formdata depending on category
			if (this.category == "car" || this.category == "moto") {
				formData = {
					user: JSON.parse(localStorage.getItem('sav-erp-user')),
					token: this.$cookie.get('sav-erp-token'),
					refreshToken: this.$cookie.get('sav-erp-refresh-token'),
					id: this.id,
					name: this.inputData[1],
					start_date: this.inputData[2],
					end_date: this.inputData[3],
					plate: this.inputData[4],
					company: this.inputData[5],
					amount: this.inputData[6],
					coverage: this.inputData[7],
					vat: this.inputData[8],
					address: this.inputData[9],
					region: this.inputData[10],
					telephone: this.inputData[11],
					notes: this.inputData[12],
					dept: this.inputData[18],
					modified_by: JSON.parse(localStorage.getItem('sav-erp-user')).username
				};
			} else if (this.category == "house") {
				formData = {
					user: JSON.parse(localStorage.getItem('sav-erp-user')),
					token: this.$cookie.get('sav-erp-token'),
					refreshToken: this.$cookie.get('sav-erp-refresh-token'),
					id: this.id,
					name: this.inputData[1],
					start_date: this.inputData[2],
					end_date: this.inputData[3],
					company: this.inputData[4],
					amount: this.inputData[5],
					coverage: this.inputData[6],
					vat: this.inputData[7],
					address: this.inputData[8],
					region: this.inputData[9],
					telephone: this.inputData[10],
					notes: this.inputData[11],
					dept: this.inputData[17],
					modified_by: JSON.parse(localStorage.getItem('sav-erp-user')).username
				};
			} else {
				formData = {
					user: JSON.parse(localStorage.getItem('sav-erp-user')),
					token: this.$cookie.get('sav-erp-token'),
					refreshToken: this.$cookie.get('sav-erp-refresh-token'),
					id: this.id,
					name: this.inputData[1],
					start_date: this.inputData[2],
					end_date: this.inputData[3],
					members: this.inputData[4],
					company: this.inputData[5],
					amount: this.inputData[6],
					coverage: this.inputData[7],
					vat: this.inputData[8],
					address: this.inputData[9],
					region: this.inputData[10],
					telephone: this.inputData[11],
					notes: this.inputData[12],
					dept: this.inputData[18],
					modified_by: JSON.parse(localStorage.getItem('sav-erp-user')).username
				};
			}

			// post request update
			axios.post(url, formData, headers)
				.then(response => {
					if (response.status == 200) {
						this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
						this.errorMsg = "";
						this.id = response.data.data.insertId;
						this.uploadPdfNames();
					} else if (response.status == 208) {
						this.errorMsg = response.data;
						this.isLoading = false;
					} else {
						this.errorMsg = response.status + "--" + response.statusText;
						this.isLoading = false;
					} 
				})
				.catch(error => {
					let response = error.response;
					
					if (response.status == 401) {
						localStorage.removeItem('user');    
						vm.$cookie.delete('sav-erp-token');
						vm.$cookie.delete('sav-erp-refresh-token');
						vm.$router.push("/login");
					} else {
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
						vm.isLoading = false;
					}
				});
		},
		uploadPdfNames () {
			let vm = this;
			let formData = '';
			let url = this.apiUrl + '/post/' + this.category + '/pdf';
			let headers = { 
				headers: {
				'Content-type': 'application/json',
				}
			};

			let tempKey = '';
			let tempValue = '';
			let docsJson = {
				doc_1: '',
				doc_2: '',
				doc_3: '',
				doc_4: ''
			}
			let fileHash = {}
			fileHash.doc_1 = `doc_1_${this.getFileHash()}`
			fileHash.doc_2 = `doc_2_${this.getFileHash()}`
			fileHash.doc_3 = `doc_3_${this.getFileHash()}`
			fileHash.doc_4 = `doc_4_${this.getFileHash()}`

			for (let doci = 1; doci <= 4; doci++) {
				if (this.file['docs_' + doci]) {
					docsJson['doc_' + doci] = ' { ';
					for (let j = 0; j < this.file['docs_' + doci].length; j++) {
						tempKey = '"part_' + (j + 1) + '"';
						tempValue = `"${this.category}/${this.id}/${fileHash['doc_' + doci]}_${this.file['docs_' + doci][j]['name']}"`;
						docsJson['doc_' + doci] = docsJson['doc_' + doci].concat(tempKey + ':' +  tempValue);
						if ( j != this.file['docs_' + doci].length - 1) {
							docsJson['doc_' + doci] = docsJson['doc_' + doci].concat(', ');
						}
					}
					docsJson['doc_' + doci] = docsJson['doc_' + doci].concat( ' }');
				} else {
					docsJson['doc_' + doci] = this.category == 'house' ? this.inputData[11 + doci] : this.inputData[11 + doci + 1];
				}
			}

			formData = {
				user: JSON.parse(localStorage.getItem('sav-erp-user')),
				token: this.$cookie.get('sav-erp-token'),
				refreshToken: this.$cookie.get('sav-erp-refresh-token'),
				id: this.id,
				docs_1: docsJson['doc_1'],
				docs_2: docsJson['doc_2'],
				docs_3: docsJson['doc_3'],
				docs_4: docsJson['doc_4']
			};

			// post request update
			axios.post(url, formData, headers)
				.then(response => {
					if (response.status == 200) {
						this.errorMsg = "";
						this.uploadFile1(fileHash);
					}  else {
						this.errorMsg = response.status + "--" + response.statusText;
						this.isLoading = false;
					} 
				})
				.catch(error => {
					let response = error.response;
					
					if (response.status == 401) {
						localStorage.removeItem('user');    
						vm.$cookie.delete('sav-erp-token');
						vm.$cookie.delete('sav-erp-refresh-token');
						vm.$router.push("/login");
					} else {
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
						vm.isLoading = false;
					}
				});
		},
		uploadFile1 (fileHash) {
			if (this.file['docs_1']) {
				let vm = this;
				let formData = new FormData();
				formData.append("category", this.category);
				formData.append("id", this.id);
				formData.append("fileHash", fileHash.doc_1);

				for(let i =0; i < this.file['docs_1'].length; i++){
					formData.append("docs", this.file['docs_1'][i], this.file['docs_1'][i]['name']);
				}
			
				formData.append("user", localStorage.getItem('sav-erp-user'));
				formData.append("token", this.$cookie.get('sav-erp-token'));

				let header = { header: {'Content-Type': 'multipart/form-data' } };

				// post request for file upload
				axios.post(this.apiUrl + '/upload-file', formData, header)
					.then(response => {
						if (response.status == 200) {
							this.uploadFile2(fileHash);
						} else {
							this.errorMsg = response.status + "-" + response.statusText;
						}
					})
					.catch(function (error) {
						let response = error.response;
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
						vm.isLoading = false;
					});
			} else {
				this.uploadFile2(fileHash);
			}
		},
		uploadFile2 (fileHash) {
			if (this.file['docs_2']) {
				let vm = this;
				let formData = new FormData();
				formData.append("category", this.category);
				formData.append("id", this.id);
				formData.append("fileHash", fileHash.doc_2);

				for(let i =0; i < this.file['docs_2'].length; i++){
					formData.append("docs", this.file['docs_2'][i], this.file['docs_2'][i]['name']);
				}
			
				formData.append("user", localStorage.getItem('sav-erp-user'));
				formData.append("token", this.$cookie.get('sav-erp-token'));

				let header = { header: {'Content-Type': 'multipart/form-data' } };

				// post request for file upload
				axios.post(this.apiUrl + '/upload-file', formData, header)
					.then(response => {
						if (response.status == 200) {
							this.uploadFile3(fileHash);
						} else {
							this.errorMsg = response.status + "-" + response.statusText;
						}
					})
					.catch(function (error) {
						let response = error.response;
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
						vm.isLoading = false;
					});
			} else {
				this.uploadFile3();
			}
		},
		uploadFile3 (fileHash) {
			if (this.file['docs_3']) {
				let vm = this;
				let formData = new FormData();
				formData.append("category", this.category);
				formData.append("id", this.id);
				formData.append("fileHash", fileHash.doc_3);

				for(let i =0; i < this.file['docs_3'].length; i++){
					formData.append("docs", this.file['docs_3'][i], this.file['docs_3'][i]['name']);
				}
			
				formData.append("user", localStorage.getItem('sav-erp-user'));
				formData.append("token", this.$cookie.get('sav-erp-token'));

				let header = { header: {'Content-Type': 'multipart/form-data' } };

				// post request for file upload
				axios.post(this.apiUrl + '/upload-file', formData, header)
					.then(response => {
						if (response.status == 200) {
							this.uploadFile4(fileHash);
						} else {
							this.errorMsg = response.status + "-" + response.statusText;
						}
					})
					.catch(function (error) {
						let response = error.response;
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
						vm.isLoading = false;
					});
			} else {
				this.uploadFile4(fileHash);
			}
		},
		uploadFile4 (fileHash) {
			if (this.file['docs_4']) {
				let vm = this;
				let formData = new FormData();
				formData.append("category", this.category);
				formData.append("id", this.id);
				formData.append("fileHash", fileHash.doc_4);

				for(let i =0; i < this.file['docs_4'].length; i++){
					formData.append("docs", this.file['docs_4'][i], this.file['docs_4'][i]['name']);
				}
			
				formData.append("user", localStorage.getItem('sav-erp-user'));
				formData.append("token", this.$cookie.get('sav-erp-token'));

				let header = { header: {'Content-Type': 'multipart/form-data' } };

				// post request for file upload
				axios.post(this.apiUrl + '/upload-file', formData, header)
					.then(response => {
						if (response.status == 200) {
							this.errorMsg = "";
							this.$router.push("/" + this.category + "/" + this.id);
						} else {
							this.errorMsg = response.status + "-" + response.statusText;
						}
					})
					.catch(function (error) {
						let response = error.response;
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
						vm.isLoading = false;
					});
			} else {
				this.errorMsg = "";
				this.$router.push("/" + this.category + "/" + this.id);
			}
		},
		getFileHash () {
			return `${Date.now()}`
		}
  },
  created () {
    this.initInputData();    
    this.initCardHeader();    
  }
}
</script>

<style lang="scss" scoped>
@import "./../scss/_colors";

#error-msg {
	color: $red;
	font-weight: 400;
	padding: 10px;
	margin-right: 10px;
}

.error-msg-infield {
	color: $red;
	font-weight: 400;
}
</style>
